(() => {
  if (window.__dovelkaCartExtrasLoaded) return;
  window.__dovelkaCartExtrasLoaded = true;

  const sectionId = 'cart-drawer-section';
  const root = window.Shopify?.routes?.root || '/';
  const addUrl = `${root}cart/add.js`;
  const changeUrl = `${root}cart/change.js`;
  const cartUrl = `${root}cart.js`;

  const updateTimer = () => {
    const timer = document.querySelector('[data-dovelka-cart-timer]');
    if (!timer) return;

    const duration = Number(timer.dataset.duration || 10) * 60;
    const storageKey = 'dovelka-cart-reservation-expires';
    let expires = Number(sessionStorage.getItem(storageKey));

    if (!expires || expires <= Date.now()) {
      expires = Date.now() + duration * 1000;
      sessionStorage.setItem(storageKey, String(expires));
    }

    const remaining = Math.max(0, Math.ceil((expires - Date.now()) / 1000));
    const minutes = Math.floor(remaining / 60);
    const seconds = String(remaining % 60).padStart(2, '0');
    const template = timer.dataset.template || 'Your items are reserved for the next [time]';
    timer.textContent = template.replace('[time]', `${minutes}:${seconds}`);

    if (remaining === 0) sessionStorage.removeItem(storageKey);
  };

  const refreshDrawer = async (sections, itemCount) => {
    const html = sections?.[sectionId];
    if (html) {
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const nextInner = documentFragment.querySelector('.cart-drawer__inner');
      const currentInner = document.querySelector('#cart-drawer .cart-drawer__inner');
      if (nextInner && currentInner) currentInner.replaceWith(nextInner);
    }

    const cartIcon = document.querySelector('cart-icon');
    if (cartIcon && typeof cartIcon.renderCartBubble === 'function') {
      cartIcon.renderCartBubble(itemCount);
    }

    updateTimer();
  };

  const updateProtection = async (input) => {
    const card = input.closest('[data-dovelka-protection-card]');
    if (!card) return;

    const variantId = Number(card.dataset.variantId);
    const lineKey = card.dataset.lineKey;
    const error = card.querySelector('[data-dovelka-protection-error]');
    const intendedChecked = input.checked;

    if (!variantId) {
      input.checked = false;
      if (error) {
        error.textContent = 'Shipping protection is not configured yet.';
        error.hidden = false;
      }
      return;
    }

    input.disabled = true;
    card.setAttribute('aria-busy', 'true');
    if (error) error.hidden = true;

    try {
      const payload = intendedChecked
        ? { items: [{ id: variantId, quantity: 1 }], sections: sectionId, sections_url: window.location.pathname }
        : { id: lineKey, quantity: 0, sections: sectionId, sections_url: window.location.pathname };

      const response = await fetch(intendedChecked ? addUrl : changeUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'Unable to update cart.');

      const cartResponse = await fetch(cartUrl, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      if (!cartResponse.ok) throw new Error('Unable to refresh cart.');
      const cart = await cartResponse.json();
      await refreshDrawer(data.sections, cart.item_count);
    } catch (requestError) {
      input.checked = !intendedChecked;
      input.disabled = false;
      card.removeAttribute('aria-busy');
      if (error) {
        error.textContent = requestError instanceof Error ? requestError.message : 'Unable to update cart.';
        error.hidden = false;
      }
    }
  };

  document.addEventListener('change', (event) => {
    const input = event.target instanceof Element ? event.target.closest('[data-dovelka-protection-toggle]') : null;
    if (input instanceof HTMLInputElement) updateProtection(input);
  });

  document.addEventListener('shopify:section:load', updateTimer);
  updateTimer();
  window.setInterval(updateTimer, 1000);
})();